import { LightningElement, api } from 'lwc';

export default class gwButtonBrandLarge extends LightningElement {
    @api label = 'Button';

    handleClick(event) {
        this.dispatchEvent(new CustomEvent('clicked', { detail: event } ));
    }

    handleMouseMove(event) {
        const rect = event.currentTarget.getBoundingClientRect();

        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;

        event.currentTarget.style.setProperty('--x', `${x}%`);
        event.currentTarget.style.setProperty('--y', `${y}%`);
    }
}